module.exports=function(n){var r=!String(n).split(".")[1];return 1==n&&r?"one":"other"}


//////////////////
// WEBPACK FOOTER
// ./~/javascript-time-ago/locale/en/quantify.js
// module id = 678
// module chunks = 0